import { useEffect, useRef, useState } from 'preact/hooks'
import SwiperInstance from 'customs/swiper-instance'
import Icon from 'snippets/icon/icon'

export default function CarouselSwiper({
  children,
  classWrapper,
  className,
  classNavigation = '',
  selector,
  options,
  navigation = false,
  pagination = false,
  scrollbar = true,
  keyboard = false,
  thumbnail = null,
  zoom = false,
  customPagination = false,
  customNavigation = false,
  grid = false
}) {
  const config = { navigation, pagination, scrollbar, keyboard, thumbnail, zoom, customPagination, customNavigation, grid }
  const swiperRef = useRef(null)
  const [instance, setInstance] = useState(null)

  useEffect(() => {
    const currentOptions = {
      ...options,
      on: {
        init: () => {
          swiperRef.current.classList.add('swiper-initialized')
        }
      }
    }
    const carouselInstance = new SwiperInstance(swiperRef.current, currentOptions, config)

    setInstance(carouselInstance)
  }, [])

  return (
    children && (
      <div
        className={`swiper-wrapper relative flex flex-col ${classWrapper}`}
        ref={swiperRef}
        data-selector={selector}
        data-type="component"
      >
        <swiper-container className={`swiper ${className} ${selector}`} init="false">
          {children}
        </swiper-container>
        {navigation && (
          customNavigation ? (
            <div class="swiper-custom-navigation">
              <div class="swiper-button-prev js-carousel-prev">
                <Icon name="icon-chevron-left" viewBox="0 0 24 24" className="w-5 h-5" />
              </div>
              <div class="swiper-button-next js-carousel-next">
                <Icon name="icon-chevron-right" viewBox="0 0 24 24" className="w-5 h-5" />
              </div>
            </div>
          ) : (
            pagination && customPagination ? (
              <div className="relative flex items-center justify-center gap-8 swiper-custom-pagination text-grey-700">
                <div className="swiper-button-prev js-carousel-prev">
                  <Icon name="icon-chevron-left" viewBox="0 0 24 24" className="w-4 h-4 text-grey-500" />
                </div>
                {pagination && <div className="swiper-pagination js-carousel-pagination"></div>}
                <div className="swiper-button-next js-carousel-next">
                  <Icon name="icon-chevron-right" viewBox="0 0 24 24" className="w-4 h-4 text-grey-500" />
                </div>
              </div>
            ) : (
              <div className={classNavigation}>
                <div className="swiper-button-prev js-carousel-prev">
                  <Icon name="icon-chevron-left" viewBox="0 0 24 24" className="w-5 h-5" />
                </div>
                <div className="swiper-button-next js-carousel-next">
                  <Icon name="icon-chevron-right" viewBox="0 0 24 24" className="w-5 h-5" />
                </div>
              </div>
            )
          )
        )}
        {pagination && !customPagination && <div className="swiper-pagination js-carousel-pagination"></div>}
        {scrollbar && <div className="swiper-scrollbar js-carousel-scrollbar"></div>}
      </div>
    )
  )
}
